export default __webpack_public_path__ + "static/media/questionBank.66d9e5ac.svg";